import { useMemo } from 'react';

import { adjustColorAlpha } from 'utils/colorConvert';
import { addHoverStyle, addOutlineBtnHoverStyle } from 'styles/common';

export default function useSystemBtnStyleByTheme(themeStyle = {}) {
    const [
        primaryBtnStyle,
        primaryOutlinedBtnStyle,
        secondaryBtnStyle,
        secondaryOutlinedBtnStyle,
        viewPrizeListBtnStyle
    ] = useMemo(
        () => [
            addHoverStyle({
                backgroundColor: themeStyle.buttonBgColor,
                color: themeStyle.buttonTextColor,
                '& *': {
                    color: 'inherit'
                }
            }),
            addOutlineBtnHoverStyle(themeStyle.buttonBgColor),
            {
                backgroundColor: adjustColorAlpha(themeStyle.buttonBgColor, 0.16),
                border: 'none',
                color: themeStyle.buttonBgColor,
                '& *': {
                    color: 'inherit'
                },
                '&:hover': {
                    border: 'none',
                    backgroundColor: adjustColorAlpha(themeStyle.buttonBgColor, 0.3)
                }
            },
            {
                backgroundColor: adjustColorAlpha(themeStyle.buttonBgColor, 0.16),
                border: `1px solid`,
                color: themeStyle.buttonBgColor,
                '& *': {
                    color: 'inherit'
                },
                '&:hover': {
                    backgroundColor: adjustColorAlpha(themeStyle.buttonBgColor, 0.3)
                }
            },
            {
                buttonSyle: {
                    icon: themeStyle.buttonBgColor,
                    background: adjustColorAlpha(themeStyle.buttonBgColor, 0.16),
                    hoverBackground: adjustColorAlpha(themeStyle.buttonBgColor, 0.3)
                },
                numberStyle: {
                    color: themeStyle.buttonTextColor,
                    bgColor: themeStyle.buttonBgColor
                }
            }
        ],
        [themeStyle]
    );
    return {
        primaryBtnStyle,
        primaryOutlinedBtnStyle,
        secondaryBtnStyle,
        secondaryOutlinedBtnStyle,
        viewPrizeListBtnStyle
    };
}
